import { memo } from 'react';
import { Navigate } from 'react-router-dom';

import { OnboardingLayout } from '@/app/layouts';

import { useSessionIsAuthorized } from '@/entities/auth';

import { getSignInPath } from '@/shared/constants/router';
import { MetaPixelPageTracker } from '@/shared/lib/fbpixel';

export const OnboardingRootElement = memo(() => {
    const isAuthorized = useSessionIsAuthorized();

    if (!isAuthorized) {
        return (
            <Navigate
                replace
                to={getSignInPath()}
            />
        );
    }

    return (
        <>
            <MetaPixelPageTracker />
            <OnboardingLayout />
        </>
    );
});

OnboardingRootElement.displayName = 'OnboardingRootElement';
